import {minimumVersion} from './config.js';
// 新协议
function kkmhhybrid_h5_directpay (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "h5_directpay",
    },
    param:opt.param,
    on: true,
    callback: function (res,callbackName) {
      opt.callback && opt.callback(res,callbackName);
    }
  });
}

// 旧协议
function kkhybrid_h5directpay (opt) {
  hybrid({
    hybridParam: {
        schema: "kkhybrid",
        tagname: "h5directpay",
    },
    param:opt.param,
    on: true,
    callback: function (res,callbackName) {
      opt.callback && opt.callback(res,callbackName);
    }
  });
}

function formatObjectToDelEmptyvalue (obj) {
    var o = JSON.parse(JSON.stringify(obj))
    for(var key in o) {
        if (!o[key]) {
            delete o[key];    
        }
    }
    return o;
}

/**
 * 调起收银台<br>
 * kkmhhybrid://h5_directpay,wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=25526556}<br>
 * kkhybrid://h5directpay,wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=285411233}<br>
 * @param {Object} opt 参数对象,参考wiki
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function h5_directpay (opt, criticalAppVersion) {
    var param = opt.param || {};
    var pay_info = formatObjectToDelEmptyvalue(param.pay_info || {});
    var track_info = param.track_info || {};
    var obj = {
          good_id       : parseInt(param.good_id)   || 0,
          good_type     : parseInt(param.good_type) || 0,
          pay_source    : parseInt(param.pay_source)|| 0,
          from_page     : param.from_page     || '',
          pay_info      : JSON.stringify(pay_info),
          track_info    : {
              TriggerPage : track_info.TriggerPage || '',
              CurPage     : track_info.CurPage || '',
              NoticeType  : track_info.NoticeType || '',
              SendComic   : track_info.SendComic || '',
              FreePayRate : track_info.FreePayRate || '',
              TriggerItemName: track_info.trigger_item || ''
          }
    }
    
    var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion, minimumVersion);
    if(allow) {
        // 调用新协议
        kkmhhybrid_h5_directpay(opt);
    } else {
        // 调用旧协议
        kkhybrid_h5directpay(opt);
    }
}

export default h5_directpay;




// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/h5_directpay/index.js